// AppLogic.tsx
import { h, FunctionalComponent } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { PingSession, startSession } from '../../utils';
import { setSessionId } from '../../redux/slices/globalsSlice';
import logger from '../../logger';

const AppLogic: FunctionalComponent = () => {

    const appearance = useAppSelector((state) => state.appearance);
    const search = useAppSelector((state) => state.search);
    const globals = useAppSelector((state) => state.globals);
    const alias = useAppSelector((state) => state.alias);
    const auth = useAppSelector((state) => state.auth);

    const dispatch = useAppDispatch();
    const [tabStatusChanged, SetStatusChanged] = useState<boolean>(false);


    useEffect(() => {
        const handleVisibilityChange = async () => {
            if (alias.workspaceId && alias.portalId && globals.sessionId && globals.userId) {
                try {
                    if (!document.hidden) {
                        const pingResponse = await PingSession(alias.workspaceId, alias.portalId, globals.sessionId, globals.userId, globals.jwtUserIdToken,false);
                        pingResponse && dispatch(setSessionId(pingResponse?.sessionId))
                        logger.log({
                            message: "Ping session response (visibility change)",
                            ping_response: pingResponse,
                            portal_alias: alias.portalAlias,
                            workspace_id: alias.workspaceId,
                            session_id: globals.sessionId
                        });
                    }
                } catch (error) {
                    logger.error({
                        message: "Error in ping session visibility change handler",
                        error: error,
                        stacktrace: (error as any)?.stack,
                        portal_alias: alias.portalAlias,
                        workspace_id: alias.workspaceId,
                        session_id: globals.sessionId
                    });
                }
            }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [alias, globals]);

    useEffect(() => {
        const sessionStarter = async () => {
            if (alias.workspaceId && alias.portalId && globals.userId) {
                if (!globals.sessionId) {
                    try {
                        const startSessionResponse = await startSession(alias.workspaceId, alias.portalId, globals.userId, globals.jwtUserIdToken,false)
                        if (startSessionResponse?.sessionId) {
                            dispatch(setSessionId(startSessionResponse?.sessionId))
                        }
                    } catch (error) {
                        logger.error({
                            message: "Error starting session",
                            error: error,
                            stacktrace: (error as any)?.stack,
                            portal_alias: alias.portalAlias,
                            workspace_id: alias.workspaceId,
                            user_id: globals.userId
                        });
                    }

                }
            };
        };
        sessionStarter();
    }, [globals.userId, globals.jwtUserIdToken, alias.workspaceId, alias.portalId]);


    useEffect(() => {

        if (alias.workspaceId && alias.portalId && globals.sessionId && globals.userId) {
            const intervalId = setInterval(async () => {

                try {
                    if (!document.hidden) {
                        const pingResponse = await PingSession(alias.workspaceId, alias.portalId, globals.sessionId, globals.userId, globals.jwtUserIdToken,false);
                        pingResponse && dispatch(setSessionId(pingResponse?.sessionId))
                        logger.log({
                            message: "Ping session response (interval)",
                            ping_response: pingResponse,
                            portal_alias: alias.portalAlias,
                            workspace_id: alias.workspaceId,
                            session_id: globals.sessionId
                        });
                    }
                } catch (error) {
                    logger.error({
                        message: "Error in ping session interval handler",
                        error: error,
                        stacktrace: (error as any)?.stack,
                        portal_alias: alias.portalAlias,
                        workspace_id: alias.workspaceId,
                        session_id: globals.sessionId
                    });
                }
            }, 60000); // 60000 ms = 1 minute

            // Cleanup interval on component unmount
            return () => clearInterval(intervalId);
        }
    }, [alias.workspaceId, alias.portalId, globals.sessionId, globals.userId]);



    return null; // No UI rendering needed here
};

export default AppLogic;
